import { css as e } from "@microsoft/fast-element";
import { normalize as a } from "../common/normalize.js";
import { designTokens as t } from "../design-tokens.js";
import { typography as o } from "../styles/typography.js";
const l = e`
  ${a}
  :host {
    /* Base */
    display: none;
    /* Layout */
    padding: ${t.spacing["2.5"]} ${t.spacing[4]};
    justify-content: center;
    align-items: center;
    gap: ${t.spacing["2.5"]};
    /* Style */
    border-radius: ${t.borderRadius.xs};
    background-color: ${t.color.neutral[30]};
    color: ${t.color.neutral[500]};
    filter: ${t.shadow.drop.xs};
    -webkit-filter: ${t.shadow.drop.xs};
    /* Typography */
    ${o("p", "semibold")}
  }

  :host([visible]) {
    /* Base */
    display: flex;
  }

  :host::after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
  }

  :host([placement='bottom']),
  :host([placement='bottom-end']),
  :host([placement='bottom-start']) {
    margin-top: ${t.spacing[2]};
  }

  :host([placement='bottom'])::after,
  :host([placement='bottom-end'])::after,
  :host([placement='bottom-start'])::after {
    top: calc(-1 * ${t.spacing["1.5"]});
    border-left: ${t.spacing["1.5"]} solid transparent !important;
    border-right: ${t.spacing["1.5"]} solid transparent !important;
    border-bottom: ${t.spacing["1.5"]} solid
      ${t.color.neutral[30]} !important;
  }

  :host([placement='left']),
  :host([placement='left-end']),
  :host([placement='left-start']) {
    margin-left: calc(-1 * ${t.spacing[2]});
  }

  :host([placement='left'])::after,
  :host([placement='left-end'])::after,
  :host([placement='left-start'])::after {
    right: calc(-1 * ${t.spacing["1.5"]});
    border-top: ${t.spacing["1.5"]} solid transparent !important;
    border-bottom: ${t.spacing["1.5"]} solid transparent !important;
    border-left: ${t.spacing["1.5"]} solid
      ${t.color.neutral[30]} !important;
  }

  :host([placement='right']),
  :host([placement='right-end']),
  :host([placement='right-start']) {
    margin-left: ${t.spacing[2]};
  }

  :host([placement='right'])::after,
  :host([placement='right-end'])::after,
  :host([placement='right-start'])::after {
    left: calc(-1 * ${t.spacing["1.5"]});
    border-top: ${t.spacing["1.5"]} solid transparent !important;
    border-bottom: ${t.spacing["1.5"]} solid transparent !important;
    border-right: ${t.spacing["1.5"]} solid
      ${t.color.neutral[30]} !important;
  }

  :host([placement='top']),
  :host([placement='top-end']),
  :host([placement='top-start']) {
    margin-top: calc(-1 * ${t.spacing[2]});
  }

  :host([placement='top'])::after,
  :host([placement='top-end'])::after,
  :host([placement='top-start'])::after {
    bottom: calc(-1 * ${t.spacing["1.5"]});
    border-left: ${t.spacing["1.5"]} solid transparent !important;
    border-right: ${t.spacing["1.5"]} solid transparent !important;
    border-top: ${t.spacing["1.5"]} solid
      ${t.color.neutral[30]} !important;
  }

  :host([placement='left-end']),
  :host([placement='right-end']) {
    margin-top: ${t.spacing["2.5"]};
  }

  :host([placement='left-end'])::after,
  :host([placement='right-end'])::after {
    bottom: ${t.spacing[4]};
  }

  :host([placement='left-start']),
  :host([placement='right-start']) {
    margin-top: calc(-1 * ${t.spacing["2.5"]});
  }

  :host([placement='left-start'])::after,
  :host([placement='right-start'])::after {
    top: ${t.spacing[4]};
  }

  :host([placement='top-end']),
  :host([placement='bottom-end']) {
    margin-left: ${t.spacing["2.5"]};
  }

  :host([placement='top-end'])::after,
  :host([placement='bottom-end'])::after {
    right: ${t.spacing[4]};
  }

  :host([placement='top-start']),
  :host([placement='bottom-start']) {
    margin-left: calc(-1 * ${t.spacing["2.5"]});
  }

  :host([placement='top-start'])::after,
  :host([placement='bottom-start'])::after {
    left: ${t.spacing[4]};
  }
`;
export {
  l as tooltipStyles
};
